import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const archivedWorkItemsJsmRoute: InvariantJiraRoute = {
	name: 'servicedesk-archived-work-items',
	path: '/jira/servicedesk/projects/:projectKey/archived-work-items',
	exact: true,
};
